import { Pipe, PipeTransform } from "@angular/core";
import { EventContentDto } from "@api";

@Pipe({ name: "filterContents" })
export class FilterContentsPipe implements PipeTransform {
  public transform(contents: EventContentDto[], searchTerm: string): EventContentDto[] {
    if (!contents?.length) return [];
    if (!searchTerm) return contents;

    return contents.filter(content => content.title.toLowerCase().includes(searchTerm.toLowerCase()));
  }
}
